import {Directive, ElementRef, Input, OnInit} from '@angular/core';

@Directive({
  selector: '[focus-me]'
})

export class FocusMeDirective implements OnInit {
  @Input() enabled = true;

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    if (this.enabled) {
      window.setTimeout(() => {
        this.el.nativeElement.focus();
      });
    }
  }
}
